<template>
  <div class="relative flex items-center justify-center px-4 h-dvh lg:max-w-none lg:px-0">
    <div class="mx-auto flex-1 lg:p-8">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
  defineOptions({
    name: 'AuthLayout',
  });
  const { t } = useI18n();
</script>
<style lang="scss" scoped>
</style>
